// Die Stapelebenen der Oberfläche — an einer Stelle, damit sie sich
// vergleichen lassen.
//
// WARUM ES DIESE DATEI GIBT
//
// Der Scanner öffnete sich hinter dem Erfassungs-Sheet. Beide lagen auf
// `z-50`, und bei gleichem z-index gewinnt, was später im Dokument steht —
// das war das Sheet, weil Radix seinen Inhalt in ein Portal an den `<body>`
// hängt, während das Scan-Fenster an seiner Stelle im Baum blieb. Auf dem
// Tablet hieß das: Kamera-Knopf drücken, nichts passiert sichtbar, und die
// Kamera taucht erst auf, wenn die Bestellung abgebrochen wird.
//
// Zwei Zahlen, die zufällig gleich sind, sieht niemand — solange sie in
// zwei verschiedenen Dateien stehen. Hier stehen sie untereinander.
//
// DIE ORDNUNG, VON UNTEN NACH OBEN
//
//   40  Inhaltsleisten, die im Fluss liegen (BottomNav)
//   50  Dialoge und Sheets: Erfassung, Sendung, Hilfe, Dropdowns
//   60  Rückfragen ÜBER einem Dialog: ConfirmDialog, WegFrage
//   65  Das Scan-Fenster  ← diese Datei
//   70  Sitzungssachen und Mobil-Menü: ReauthDialog, MobilMenue, Tour
//   75  Nutzer hinzufügen (liegt über dem Reauth-Ablauf)
//   80  Der Ladebalken des Routers
//   90  Der Hinweis auf eine neue Fassung
//   95  Meldungen (Toasts)  ← diese Datei
//
// WARUM DER SCANNER AUF 65 LIEGT UND NICHT HÖHER
//
// Er ist Vollbild und muss über jeden Dialog, aus dem er geöffnet wird —
// das ist der behobene Fehler. Höher als nötig soll er aber nicht: Stirbt
// die Sitzung, während jemand scannt, gehört der Reauth-Dialog (70) VOR
// die Kamera und nicht dahinter. Der Scanner geht also genau so weit
// hinauf, wie der Befund es verlangt, und keinen Schritt weiter.
//
// WARUM MELDUNGEN NACH OBEN GEWANDERT SIND
//
// Toasts lagen auf 60 und damit unter dem neuen Scanner. Das wäre eine
// neue Fehlfunktion an der Stelle der alten gewesen: Der Wareneingang-Modus
// des Scanners meldet einen FEHLGESCHLAGENEN Scan oder eine
// fehlgeschlagene Buchung ausschließlich über einen Toast
// (`ScanFenster.tsx`) — bei laufender Kamera wäre genau diese Meldung
// unsichtbar geworden. Eine Meldung, die man nicht lesen kann, ist keine.
// Deshalb liegen sie jetzt über allem; sie sind ohnehin flüchtig und
// nehmen niemandem etwas weg.
//
// Der ERFOLGSFALL gehört seit A25 nicht mehr dazu: Er wird im Fenster
// selbst gemeldet, im Kurzjournal, und braucht keinen Toast. Für die
// Ebene ändert das nichts — der Fehlerfall allein trägt sie schon, und
// er ist der Fall, in dem Unsichtbarkeit wirklich schadet.
//
// Wer eine neue Ebene braucht: hier eintragen, nicht anderswo eine Zahl
// erfinden. Die Zeichenketten stehen absichtlich als vollständige
// Tailwind-Klassen da — Tailwind liest diese Datei mit (`content` in
// tailwind.config.js) und erzeugt die Klassen nur, wenn es sie wörtlich
// findet.

/** Das Scan-Fenster. Über allen Dialogen, unter den Sitzungssachen. */
export const EBENE_SCAN = 'z-[65]';

/** Meldungen. Über allem — eine Meldung, die man nicht lesen kann, ist keine. */
export const EBENE_TOAST = 'z-[95]';
